export function productHasPrice(product: {
  price?: number | null;
  variants?: { price?: number | null }[] | null;
}): boolean {
  if (product.price != null && product.price > 0) {
    return true;
  }
  return product.variants?.some((variant) => variant.price != null && variant.price > 0) ?? false;
}

export function meetingRequiresAuthentication(product: {
  requireAuthentication?: boolean | null;
  price?: number | null;
  variants?: { price?: number | null }[] | null;
}): boolean {
  return product.requireAuthentication === true || productHasPrice(product);
}
